export default __webpack_public_path__ + "static/media/csv_icon.933c6717.svg";